var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showWait)?_c('Loading'):_c('div',[_c('PageTitle',{attrs:{"main":_vm.$t('plano-de-safra') + `${ this.plan == 'BD' ? 'BUDGET' : '' } ${this.unit ? ' - '+this.unit: ''}`,"sub":"","imagem":"Planejamento.png"}}),_c('GridPlan',{attrs:{"plan":_vm.plan},on:{"unit":function($event){_vm.alterUnit=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }